module.exports = __webpack_public_path__ + "static/img/money.db6d7519.svg";